import React from "react";

const EgenControlActionSuccessPage = ({ successMsg }) => (
  <div className="text-center">
    <p className="h1">{successMsg}</p>
  </div>
);

export default EgenControlActionSuccessPage;
